import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { CREATE_STOCK_ITEM, EDIT_STOCK_ITEM, GetStockItemDataById } from "../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import { Confirm } from "../../Confirmation/Confirm";
import { handleFormReset, updateSingleField, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import AddStockItemSection from "./AddStockItemSection/AddStockItemSection";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";

const AddStockItem = ({
  show,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  ReferenceFieldName = [],
  ReferFormKey = "",
}) => {
  const Form_Key = TypeOfPortal === "Merge" ? "Stock_Item_Merge" : "Stock_Item";
  const [isFirstLoad, setFirstLoad] = useState(false);

  const formRef = useRef({});
  const { pushModal, popModal } = useModalContext();
  const fieldDataRedux = useSelector((store) => store.UniqueTableReducer);
  const fieldData = fieldDataRedux?.Stock_Item?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState();
  const dispatch = useDispatch();
  const [ConfirmMerge, SetConfirmMerge] = useState(false);
  const [toggle, setToggle] = useState(show ? show : false);
  const [formErrors, setFormErrors] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [FormData, setFormdata] = useState({});
  const [SelectedData, setSelectedData] = useState("HSN_Code");
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [TypeOfCode, setTypeOfCode] = useState({
    HSN_Code: {
      name: "HSN_Code",
      label: "HSN Code",
      type: "text",
      masterName: "HSN_Code",
      type: "InputDropForQuery",
      variable: {
        Type: "HSN_Code",
        isHSN: true,
        isSAC: false,
      },
    },
    SAC_Code: {
      name: "SAC_Code",
      label: "SAC Code",
      type: "text",
      masterName: "HSN_Code",
      type: "InputDropForQuery",
      variable: {
        Type: "SAC_Code",
        isHSN: false,
        isSAC: true,
      },
    },
  });
  const [initialData, setInitialData] = useState({})
  const { isDisabled } = useIsDisabled({ TypeOfPortal, initial: initialData, current: FormData });


  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [GetStockItemById, { loading: GetStockItemByIdLoader }] = useLazyQuery(GetStockItemDataById, {
    fetchPolicy: "network-only",
  });
  const [CreatingData, { loading: createStockItemLoading }] = useMutation(CREATE_STOCK_ITEM);

  const [EditingData, { loading: editStockItemLoading }] = useMutation(EDIT_STOCK_ITEM);

  const StockItemLoadingState = createStockItemLoading || editStockItemLoading || GetStockItemByIdLoader;

  const HanldeChangeonForm = (values) => {
    setFormdata(prev => {
      const next = { ...prev, ...values };
      if (!isFirstLoad) {
        setInitialData(next)
      }
      return next
    })
  };


  useEffect(() => {
    setSelectedRows(fieldDataRedux?.Stock_Item?.Selected_Rows);
  }, [fieldDataRedux]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);


  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    if (FormData.Opening_Balance_QTY && FormData.Purchase_Price) {
      const StockValue = FormData.Opening_Balance_QTY * FormData.Purchase_Price;
      updateSingleField(formRef, "Stock_Value", StockValue);
    }
  }, [FormData.Opening_Balance_QTY, FormData.
    Purchase_Price]);

  useEffect(() => {
    getFormSectionAndFields().then(() => {
      if (TypeOfPortal !== "Add") {
        GetStockItemById({
          variables: {
            id: fieldData?._id,
          },
        }).then(({ data }) => {
          let ItemData = { ...data?.getStockItemById };

          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Stock_Group: ItemData.Stock_Group,
                HSN_Code: ItemData.HSN_Code,
                SAC_Code: ItemData.SAC_Code,
                Sales_A_C: { ...ItemData?.Sales_A_C, Account_Balance_Id: ItemData?.Sales_A_C?._id },
                Purchase_A_C: { ...ItemData?.Purchase_A_C, Account_Balance_Id: ItemData?.Purchase_A_C?._id },
                Within_State_Tax: { ...ItemData?.Within_State_Tax },
                Outside_State_Tax: { ...ItemData?.Outside_State_Tax },
              },
            },
          });
          if (ItemData?.Stock_Group) {
            ItemData.Stock_Group = ItemData?.Stock_Group?.Group_Name;
          }
          if (ItemData?.HSN_Code) {
            ItemData.HSN_Code = ItemData?.HSN_Code?.Code;
          }

          if (ItemData?.Sales_A_C) {
            ItemData.Sales_A_C = ItemData?.Sales_A_C?.Account_Name;
          }
          if (ItemData?.Purchase_A_C) {
            ItemData.Purchase_A_C = ItemData?.Purchase_A_C?.Account_Name;
          }
          if (ItemData?.Within_State_Tax) {
            ItemData.Within_State_Tax = ItemData?.Within_State_Tax?.Tax_Group_Name;
          }
          if (ItemData?.Outside_State_Tax) {
            ItemData.Outside_State_Tax = ItemData?.Outside_State_Tax?.Tax_Group_Name;
          }

          setAllFieldsData({ ...ItemData });
          if (ItemData?.SAC_Code) {
            ItemData.SAC_Code = ItemData?.SAC_Code?.SAC_Code;

            delete ItemData._id;
            delete ItemData.__typename;
            delete ItemData.Search_Value;

            setFormdata(ItemData);
            setSelectedData("SAC_Code");
          }
          //   setTimeout(() => {
          //     console.log(ItemData, ItemData?.SAC_Code)
          //     updateValueForm(formRef, ItemData);
          //   }, 100)
          // }
          // else {
          updateValueForm(formRef, ItemData);
          // }
        });
      } else {
        setAllFieldsData({});
      }
    });
  }, [fieldData, TypeOfPortal, GetStockItemById, dispatch]);

  const { executeOperation } = useSubmitOperation();
  let formData = FormData;
  const operationType = TypeOfPortal;

  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);

  const MutationFunctions = {
    CreatingData,
    EditingData,
    // MergingData,
  };
  const submit = async (closeAction) => {
    let Name = ReferenceFieldName[0]?.name;
    let rowId = ReferenceFieldName[0]?.rowId;
    console.log(rowId, ReferenceFieldName);
    formData.Stock_Group = FormDataFromRedux?.MasterData[Form_Key]?.Stock_Group?._id;
    if (formData.HSN_Code) {
      formData.HSN_Code = FormDataFromRedux?.MasterData[Form_Key]?.HSN_Code?._id;
      formData.SAC_Code = null;
    } else if (formData.SAC_Code) {
      formData.HSN_Code = null;
      formData.SAC_Code = FormDataFromRedux?.MasterData[Form_Key]?.SAC_Code?._id;
    }
    formData.Outside_State_Tax = FormDataFromRedux?.MasterData[Form_Key]?.Outside_State_Tax?._id;
    formData.Within_State_Tax = FormDataFromRedux?.MasterData[Form_Key]?.Within_State_Tax?._id;
    formData.Sales_A_C = FormDataFromRedux?.MasterData[Form_Key]?.Sales_A_C?.Account_Balance_Id;
    formData.Purchase_A_C = FormDataFromRedux?.MasterData[Form_Key]?.Purchase_A_C?.Account_Balance_Id;
    if (!formData?.Opening_Balance_QTY) {
      delete formData?.Opening_Balance_QTY;
    }
    const mutationFunction = getMutationFunction(operationType, MutationFunctions);

    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,

        PageName: Form_Key,
        OnSuccess: (res) => {
          console.log(res);
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: ReferFormKey,
              data: {
                [rowId]: { [Name]: res?.data?.createStockItem || res?.data?.editStockItem },
              },
            },
          });
          handleFormReset(formRef);
        },
      });

    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: closeFormFunction,
      resetFormDataFunction: () => handleFormReset(formRef),
      onSuccess: () => { },
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };
  const closeFormFunction = () => {
    popModal(Form_Key);
    ParentPortalCloseFunction();
    setToggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
  };
  const SaveAndCloseForAdd = () => {
    submit("Close");
  };
  const ConfirmModalOpen = () => {
    SetConfirmMerge(true);
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={isDisabled}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => Validate_handleSubmit(SaveAndCloseForAdd)
          : TypeOfPortal === "Merge"
            ? () => ConfirmModalOpen()
            : () => Validate_handleSubmit(submit)
      }
      handleformclose={() => {
        closeFormFunction();
        setToggle(!toggle);
      }}
      loadingState={StockItemLoadingState}
    />
  );
  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={closeFormFunction}
          TypeOfPortal={TypeOfPortal + " Stock Item"}
        >
          {StockItemLoadingState && <div className="loader-line-div" />}
          <div className="formContainer">
            {inputFields && inputFields?.length > 0 ? (
              inputFields.map((e) => (
                <div key={e.id} className="FormSectionParent">
                  <div className="sectionHeadings"></div>
                  <div className="FormSection insidecontainer">
                    <AddStockItemSection
                      inputfields={e.fields}
                      Type={e.name}
                      ErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                      HanldeChangeonForm={HanldeChangeonForm}
                      formkey={Form_Key}
                      formRef={formRef}
                      TypeOfSelection={TypeOfCode}
                      SelectedData={SelectedData}
                      setSelectedData={setSelectedData}
                      FormData={FormData}
                      setFirstLoad={setFirstLoad}
                    />
                  </div>
                </div>
              ))
            ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
              <p>No form fields available.</p>
            ) : null}
          </div>
        </Reactportal>
      </div>
      {ConfirmMerge && (
        <Confirm
          submit={submit}
          settoggle={SetConfirmMerge}
          toggle={ConfirmMerge}
          loadingState={StockItemLoadingState}
          submitType={"Confirm Merge"}
          TypeOfPortal={"Confirm"}
        />
      )}
    </>
  );
};

export default AddStockItem;
